import {useEffect, useState} from 'react'
import useKeystroke from '@/hooks/useKeystroke.mjs'
import {publish, subscribeOnce} from '@/script/event.mjs'
import {TreeDocContext} from './TreeDocContext.jsx'

export default function TreeDocument({children, doc, ...props}) {
    const [isInitialized, setIsInitialized] = useState(false)

    const eventHandlers = {
        ...useKeystroke({
            onKeyDown: (e) => {
                publish(doc, 'key_down', e)
            },

            onKeyUp: (e) => {
                publish(doc, 'key_up', e)
            },
        }),
    }

    useEffect(
        () => {
            const onInit = () => setIsInitialized(true)
            subscribeOnce(doc, 'init', onInit)
        },

        []
    )

    return (
        <div
            role="document"
            tabIndex="-1"
            {...eventHandlers}
            {...props}
        >
            <TreeDocContext.Provider value={doc}>
                {isInitialized && children}
            </TreeDocContext.Provider>
        </div>
    )
}
